import { Grid, Skeleton } from "@mui/material";
import MDBox from "components/MDBox";

interface Props {
  position?: "left" | "right";
}

function TimelineItemSkeleton({ position = "left" }: Props) {
  const lineLeft = { xs: 0, md: "50%" };
  const lineTransform = { xs: "none", md: "translateX(-50%)" };

  const circulo = (
    <Grid item xs={3} sx={{ display: { xs: "none", md: "flex" }, justifyContent: "center" }}>
      <Skeleton variant="circular" width="4rem" height="4rem" />
    </Grid>
  );

  return (
    <MDBox
      position="relative"
      minHeight="120px"
      display="flex"
      sx={{
        justifyContent: {
          xs: "flex-start",
          md: position === "left" ? "flex-start" : "flex-end",
        },
      }}
    >
      {/* Línea */}
      <Skeleton
        variant="rectangular"
        sx={{
          position: "absolute",
          top: 0,
          height: "100%",
          width: "8px",
          left: lineLeft,
          transform: lineTransform,
        }}
      />

      {/* Punto */}
      <Skeleton
        variant="circular"
        width={25}
        height={25}
        sx={{
          position: "absolute",
          left: { xs: "-8px", md: "50%" },
          transform: lineTransform,
          bottom: { xs: "50%", md: 0 },
        }}
      />

      {/* Contenido */}
      <MDBox
        mt={7}
        sx={{
          width: { xs: "calc(100% - 55px)", md: "45%" },
          ml: { xs: "55px", md: 0 },
        }}
      >
        <Grid container spacing={2} alignItems="center">
          {position === "left" && circulo}
          <Grid item xs={12} md={9}>
            <Skeleton variant="text" width="50%" height={28} />
            <Skeleton variant="text" width="100%" height={10} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="80%" />
            <Skeleton variant="text" width="35%" />
          </Grid>
          {position === "right" && circulo}
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default TimelineItemSkeleton;
